import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import PropertyReqFileds from "../../components/Property/PropertyReqFileds";

const DeactivateReview = () => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [selectedImage, setSelectedImage] = useState(dummyimage);
  const [popup, setPopup] = useState(false);
  const [bannerPopup, setBannerPopup] = useState(false);
  const [state, setState] = useState();
  const [city, setCity] = useState();
  const [fromDate, setFormDate] = useState();
  const [toDate, setToDate] = useState();
  const [activeStatus, setActiveStatus] = useState(1);

  const [owners, setOwners] = useState([
    {
      Bookingid: "BKG123456",
      Property: "Sea View BKG987654",
      OwnerName: "Robert Downey",
      UserName: "John Smith",
      PropertyLocation: "Chennai, Tamil Nadu",
      Star: "5 ⭐️",
      Description: "Luxury villa with private beach",
      status: "Requested",
    },
    {
      Bookingid: "BKG987654",
      Property: "Mountain BKG987654",
      OwnerName: "Chris Hemsworth",
      UserName: "Emma Johnson",
      PropertyLocation: "Bengaluru, Karnataka",
      Star: "4 ⭐️",
      Description: "Cozy cottage in the hills",
      status: "Accepted",
    },
    {
      Bookingid: "BKG456789",
      Property: "City Center BKG987654",
      OwnerName: "Mark Ruffalo",
      UserName: "Liam Brown",
      PropertyLocation: "Hyderabad, Telangana",
      Star: "3 ⭐️",
      Description: "Modern apartment near IT hub",
      status: "Rejected",
    },
    {
      Bookingid: "BKG112233",
      Property: "Beachfront BKG987654",
      OwnerName: "Scarlett Johansson",
      UserName: "Sophia Wilson",
      PropertyLocation: "Mumbai, Maharashtra",
      Star: "5 ⭐️",
      Description: "Beautiful bungalow right on the beach",
      status: "Requested",
    },
    {
      Bookingid: "BKG998877",
      Property: "Heritage BKG987654",
      OwnerName: "Jeremy Renner",
      UserName: "Ethan Davis",
      PropertyLocation: "Kochi, Kerala",
      Star: "4 ⭐️",
      Description: "Traditional haveli with antique decor",
      status: "Accepted",
    },
    {
      Bookingid: "BKG554433",
      Property: "Lake View BKG987654",
      OwnerName: "Chris Evans",
      UserName: "Ava Martinez",
      PropertyLocation: "New Delhi, Delhi",
      Star: "5 ⭐️",
      Description: "Resort with stunning lake views",
      status: "Rejected",
    },
    {
      Bookingid: "BKG223344",
      Property: "Farmhouse BKG987654",
      OwnerName: "Paul Rudd",
      UserName: "Noah Garcia",
      PropertyLocation: "Amritsar, Punjab",
      Star: "4 ⭐️",
      Description: "Peaceful farmhouse surrounded by greenery",
      status: "Requested",
    },
    {
      Bookingid: "BKG667788",
      Property: "Riverside BKG987654",
      OwnerName: "Elizabeth Olsen",
      UserName: "Mia Anderson",
      PropertyLocation: "Kolkata, West Bengal",
      Star: "3 ⭐️",
      Description: "Charming cottage by the river",
      status: "Accepted",
    },
  ]);

  const handleCheckboxChange = (index) => {
    const updated = [...owners];
    updated[index].selected = !updated[index].selected;
    setOwners(updated);
  };

  const handleImageClick = () => {
    inputRef.current.click();
  };
  const handleStatus = ({ id }) => {
    const updatedData = [...owners]; // Create a copy of the data
    const currentStatus = updatedData[id].status || "on"; // Default to "on" if undefined

    updatedData[id].status = currentStatus === "on" ? "off" : "on";
    setOwners(updatedData);
    console.log("KK", id);
    // let value = data.filter((ele, i) => i == id ? ele.status == "off" ? "on" : "off")
  };

  const users = [
    { id: 1, name: "Chennai", age: 28, city: "New York" },
    { id: 2, name: "Banglore", age: 34, city: "Los Angeles" },
    { id: 3, name: "Hyderabad", age: 22, city: "Chicago" },
    { id: 4, name: "Nellore", age: 25, city: "Miami" },
    { id: 5, name: "Guntur", age: 40, city: "San Francisco" },
  ];
  const ownerList = [
    { id: 1, name: "John Doe", age: 28, city: "New York" },
    { id: 2, name: "Jane Smith", age: 34, city: "Los Angeles" },
    { id: 3, name: "Sam Brown", age: 22, city: "Chicago" },
    { id: 4, name: "Emily Johnson", age: 25, city: "Miami" },
    { id: 5, name: "Michael Davis", age: 40, city: "San Francisco" },
  ];
  const options = users.map((item) => {
    let obj = {};
    obj.value = item.name;
    obj.label = item.name;
    return obj;
  });
  const ownerOptions = ownerList.map((item) => {
    let obj = {};
    obj.value = item.name;
    obj.label = item.name;
    return obj;
  });

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },

      {
        Header: " Booking ID",
        accessor: "Bookingid",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Property",
        accessor: "Property",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Owner Name",
        accessor: "OwnerName",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "User Name",
        accessor: "UserName",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: " Property Location",
        accessor: "PropertyLocation",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Star",
        accessor: "Star",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Description",
        accessor: "Description",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-js gap-3">
                <button
                  onClick={() => {
                    navigate("/reviewview", {
                      state: { type: "view-deactive" },
                    });
                  }}
                  className="cust-btn "
                >
                  <img src={view_icon} alt="" className=" edit-btn " />
                </button>

                <button onClick={() => setPopup(true)} className="cust-btn ">
                  <img src={delete_icon} alt="" className=" edit-btn " />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );

  return (
    <div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">

            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false)
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeactivateReview;
